import React from 'react';
import ReviewStarRatingListItem from './ReviewStarRatingListItem';
import { IRatingVM } from '@lialo/core/lib/pages/tourDetail/models';
import { List } from '@mui/material';

interface IProps {
  ratings: IRatingVM[];
}

export const ReviewListComponent = (props: IProps) => {
  return props.ratings.length > 0 ? (
    <List id={'tour-ratings'}>
      {props.ratings.map((rating, idx) => {
        return <ReviewStarRatingListItem key={rating.user?.id ?? idx} {...rating} />;
      })}
    </List>
  ) : null;
};
